(function () {
  function bindSlider(el) {
    if (!el || el.dataset.lifeMxBound === '1') return;
    el.dataset.lifeMxBound = '1';

    let active = false;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    el.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        active = true;
        moved = false;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        el.setPointerCapture(e.pointerId);
        el.classList.add('is-dragging');
      },
      { passive: true }
    );

    el.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!active) return;
      active = false;
      el.classList.remove('is-dragging');
      try {
        el.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', function (e) {
      if (active) endDrag(e);
    });

    // Avoid accidental click-through after a drag
    el.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-life-mx-slider]').forEach(bindSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
